"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Environment = _interopRequireDefault(require("./utils/Environment"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
var ApopheniaLogger = /*#__PURE__*/
function () {
  _createClass(ApopheniaLogger, [{
    key: "send",
    value: function send(eventName) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
      if (this.environment === 'dev') {
        if (!eventName || typeof eventName !== 'string') {
          throw new Error('Cannot send log without event name');
        }
      }
      var preparedRecord = this._prepareRecord(eventName, fields);
      if (this.environment === 'dev') {
        console.log('🗣 Loggly Message: ', preparedRecord); // eslint-disable-line no-console

        callback(null);
        return;
      }
      return this._sendToLogService(preparedRecord, callback);
    }
  }], [{
    key: "initialize",
    value: function initialize(config) {
      return new ApopheniaLogger(config);
    }
  }]);
  function ApopheniaLogger(config) {
    _classCallCheck(this, ApopheniaLogger);
    this._enforceConfig(config);
    this.appId = config.appId;
    this.environment = _Environment["default"].get();
    this.logServiceUrl = "https://apophenia.".concat(_Environment["default"].prefix(), "ramseysolutions.net/v1");
    this.logApiKey = config.apiKey;
  }
  _createClass(ApopheniaLogger, [{
    key: "_prepareRecord",
    value: function _prepareRecord(eventName, record) {
      record.action = eventName;
      record.app_id = this.appId;
      record.time = new Date().toISOString();
      return record;
    }
  }, {
    key: "_enforceConfig",
    value: function _enforceConfig(config) {
      if (!config.appId || !config.apiKey) {
        var missingSettingsError = 'Logs cannot be initialized without the following settings: `appId` and `apiKey`.';
        throw new Error(missingSettingsError);
      }
    }
  }, {
    key: "_sendToLogService",
    value: function _sendToLogService(record, callback) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', this.logServiceUrl);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('x-api-key', this.logApiKey);
      xhr.onload = function () {
        return callback(xhr);
      };
      xhr.send(JSON.stringify({
        records: [record]
      }));
    }
  }]);
  return ApopheniaLogger;
}();
var _default = ApopheniaLogger;
exports["default"] = _default;